<template>
  <Card
    class="w-full mb-30"
    centerContent
    :title="$t('health_actions.survey.survey')"
    icon="Checklist"
    accentColor="sky"
  >
    <div v-if="memberCompletedSurveyThisPeriod(memberId)" class="flex flex-col items-center p-20">
      <CheckCircle class="w-24 h-24 mb-6 text-green-500" />
      <Body>
        <span class="font-bold">
          {{ $t('health_actions.survey.completed') }}
        </span>
          {{ mostRecentSurveyCompletion(memberId) | FD }}
      </Body>
    </div>
    <div v-else class="w-full p-20">
      <SurveyToDoDetails />
    </div>
  </Card>
</template>

<script>
import { Card } from '~/components/common/card/index';
import { CheckCircle } from '@assets/svgs/index'
import healthActionMixin from '@platform-shared/mixins/health-actions/healthActionMixin.js'
import SurveyToDoDetails from './SurveyToDoDetails.vue';

export default {
  components: {
    Card,
    CheckCircle,
    SurveyToDoDetails,
  },
  mixins: [healthActionMixin],
  props: {
    memberId: {
      type: Number,
      required: false,
      default: undefined,
    },
  },
}
</script>